var React = require('react');

function ViewedChecked (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.035 10.507a8.814 8.814 0 0 1-3.785.849C4.5 11.356 1.298 9.023 0 5.73 1.298 2.438 4.5.106 8.25.106s6.953 2.332 8.25 5.625a8.85 8.85 0 0 1-.178.42 5.003 5.003 0 0 0-4.287 4.356zM8.25 9.481a3.751 3.751 0 0 1 0-7.501c2.07 0 3.75 1.68 3.75 3.75 0 2.07-1.68 3.75-3.75 3.75zm0-6A2.247 2.247 0 0 0 6 5.73a2.247 2.247 0 0 0 2.25 2.25 2.247 2.247 0 0 0 2.25-2.25 2.247 2.247 0 0 0-2.25-2.25zm8.61 8.148l-2.133-2.177-.727.736 2.86 2.918L23 6.842l-.721-.736-5.419 5.523z","fill":"currentColor","fillRule":"evenodd"}));
}

ViewedChecked.defaultProps = {"width":"23","height":"14","viewBox":"0 0 23 14"};

module.exports = ViewedChecked;

ViewedChecked.default = ViewedChecked;
